import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from "axios";
import { Link, navigate } from 'raviger';
import { Button, Card, Col, InputGroup, ListGroup, Modal, OverlayTrigger, Row, Tooltip, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faArrowRightArrowLeft, faChevronCircleDown, faChevronCircleUp, faEdit, faEye, faEyeSlash, faPlusSquare, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { faCircleT, faHomeHeart, faPhonePlus, faRightLeft } from '@fortawesome/pro-solid-svg-icons';
import Moment from 'react-moment';
import ExistingPersonSearch from '../components/ExistingPersonSearch';
import clsx from 'clsx';
import * as Yup from 'yup';
import { Formik } from "formik";
import MaterialCheckbox from '@mui/material/Checkbox';
import { makeStyles } from '@mui/styles';
import Header from '../components/Header';
import { Checkbox } from '../components/Form';
import History from '../components/History';
import Scrollbar from '../components/Scrollbars';
import AnimalCards from '../components/AnimalCards';
import PhotoDocuments from '../components/PhotoDocuments';
import { SystemErrorContext } from '../components/SystemError';
import { capitalize } from '../utils/formatString';
import LoadingLink from '../components/LoadingLink';
import ActionsDropdown from '../components/ActionsDropdown';

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    color: 'white',
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: '#DFDDDD',
      cursor: 'not-allowed',
      pointerEvents: 'all !important',
      title: 'test'
    },
  },
  checkedIcon: {
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
  checked: {},
});

function PreRegOwnerDetails({id, organization}) {

  const classes = useStyles();

  const { setShowSystemError } = useContext(SystemErrorContext);

  const existingOwnerRef = useRef(null);

  const [isPersonLoading, setIsPersonLoading] = useState(true);
  const [showHidden, setShowHidden] = useState(false);
  const [selectedAnimals, setSelectedAnimals] = useState([]);
  const [showHideModal, setShowHideModal] = useState(false);
  const handleShowHideClose = () => setShowHideModal(false);
  const [showTransfer, setShowTransfer] = useState(false);
  const handleCloseTransfer = () => setShowTransfer(false);
  const [transferData, setTransferData] = useState({'new_owner_id':null, 'animal_ids':[]});

  const [data, setData] = useState({
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    comments: '',
    // agency: '',
    drivers_license: '',
    address: '',
    apartment: '',
    city: '',
    state: '',
    zip_code: '',
    evac_zone: '',
    pre_reg_animals: [],
    reporter_animals: [],
    requests: [],
    images: [],
    owner_contacts: [],
    action_history: [],
    change_reasons: [],
    animal_ids: []
  });

  // Handle animal show/hide submit.
  const handleShowHideSubmit = async () => {
    setIsPersonLoading(true);
    await axios.patch('/people/api/pre-reg-person/' + id + '/', {hide_animals:selectedAnimals, show_hide:!showHidden})
    .then(response => {
      setData(prevState => ({ ...prevState, "pre_reg_animals":prevState['pre_reg_animals'].map(animal => ({...animal, "hidden":selectedAnimals.includes(animal.id) ? !showHidden : animal.hidden})) }));
      setSelectedAnimals([]);
      handleShowHideClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsPersonLoading(false));
  }

  const showHideOwner = async (owner_id, bool) => {
    await axios.patch('/people/api/person/' + owner_id + '/', {'hidden':bool})
    .then(response => {
      setData(prevState => ({ ...prevState, "hidden": bool }));
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();
    setIsPersonLoading(true);

    const fetchPersonData = async () => {
      // Fetch Person data.
      await axios.get('/people/api/pre-reg-person/' + id + '/?hidden_animals=true', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          response.data["animal_ids"] = [];
          setData(response.data);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      })
      .finally(() => setIsPersonLoading(false));
    };
    fetchPersonData();

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [id]);

  const isLoading = isPersonLoading;

  return (
    <>
    <Header><span id="back" style={{cursor:'pointer'}} onClick={(e) => {navigate("/" + organization + "/manage/owners")}} className="me-3"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="lg" inverse /></span>
    Preregistered Owner Details</Header>
    <div className="row">
      <div className="col-6 d-flex">
        <Card className="border rounded" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-10px"}}>
              <h4 style={{paddingTop:"5px"}}>Information
                {data.training ? <OverlayTrigger
                  key={"owner-training"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-owner-training`}>
                      This owner is flagged for training purposes.
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faCircleT} className="ms-1" size="sm" />
                </OverlayTrigger> : ""}

              </h4>
              {isLoading ? (
                <Spinner
                  className="align-self-center me-3"
                  {...{
                    as: 'span',
                    animation: 'border',
                    size: undefined,
                    role: 'status',
                    'aria-hidden': 'true',
                    variant: 'light',
                    style: {
                      height: '1.5rem',
                      width: '1.5rem',
                      marginBottom: '0.75rem'
                    }
                  }}
                />
              ) : (
                <ActionsDropdown variant="secondary" title="Actions">
                  <LoadingLink
                    href={"/" + organization + "/manage/owners/edit/" + id}
                    isLoading={isLoading}
                    className="d-block"
                    label="Update Owner"
                  >
                    <FontAwesomeIcon icon={faEdit} className="fas" inverse />
                  </LoadingLink>
                  {data.hidden ?
                  <LoadingLink
                    onClick={() => showHideOwner(data.id, false)}
                    className="d-block"
                    isLoading={false}
                    label="Make Owner Discoverable"
                    >
                    <FontAwesomeIcon icon={faEye} className="fas" inverse />
                  </LoadingLink>
                  :
                  <LoadingLink
                    onClick={() => showHideOwner(data.id, true)}
                    className="d-block"
                    isLoading={false}
                    label="Hide Owner From Discovery"
                    >
                    <FontAwesomeIcon icon={faEyeSlash} className="fas" inverse />
                  </LoadingLink>
                  }
                </ActionsDropdown>
              )}
            </div>
            <p className="phr"/>
            <Scrollbar no_shadow="true" style={{height:"222px", marginBottom:"-10px"}} renderView={props => <div {...props} style={{...props.style, marginBottom:"-19px"}}/>} renderThumbHorizontal={props => <div {...props} style={{...props.style, display: 'none'}} />}>
              <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
                <ListGroup.Item><b>Name: </b>{data.first_name} {data.last_name}</ListGroup.Item>
                {/* {data.agency ? <ListGroup.Item><b>Agency: </b>{data.agency}</ListGroup.Item>: ''} */}
                {data.phone ? <ListGroup.Item><b>Telephone: </b>{data.display_phone} {data.display_alt_phone ? <span>|&nbsp;Alt: {data.display_alt_phone}</span> : ""}</ListGroup.Item> : ""}
                {data.email ? <ListGroup.Item><b>Email: </b>{data.email}</ListGroup.Item> : ""}
                {data.address ?
                  <ListGroup.Item><b>Address: </b>{data.full_address}</ListGroup.Item>
                : ""}
                {data.comments ? <ListGroup.Item><b>Comments: </b>{data.comments}</ListGroup.Item>: ''}
              </ListGroup>
            </Scrollbar>
          </Card.Body>
        </Card>
      </div>
    </div>
    <div className="row mt-3">
      <div className="col-12 d-flex">
        <Card className="border rounded" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px", marginBottom:"-15px"}}>
            <div style={{marginBottom:"-10px"}}>
              <Row style={{marginBottom:"-12px"}}>
                <Col>
                  <InputGroup>
                    <ListGroup horizontal flush style={{marginBottom:"-4px"}}>
                      <ListGroup.Item className="border" active={showHidden === false} style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"5px", paddingRight:"5px", marginRight:"-1px"}} onClick={() => {setShowHidden(false);}}>
                        <div className="text-center" style={{fontSize:"16px", width:"270px"}}>
                          Discoverable Preregistered Animals
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item className="border" active={showHidden === true} style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"5px", paddingRight:"5px"}} disabled={data.pre_reg_animals.filter(animal => animal.hidden === true).length === 0} onClick={() => {setShowHidden(true);}}>
                        <div className="text-center" style={{fontSize:"16px", width:"270px"}}>
                          Hidden Preregistered Animals
                        </div>
                      </ListGroup.Item>
                    </ListGroup>
                  </InputGroup>
                </Col>
                <Col xs={1} className="float-end">
                  <ActionsDropdown variant="secondary" title="Actions" className="float-end" style={{marginTop:"-1px"}}>
                    <LoadingLink
                      href={"/" + organization + "/manage/animals/new?owner_id=" + data.id}
                      isLoading={isLoading}
                      className="d-block"
                      label="Add an Animal"
                      disabled={showHidden}
                      disabled_text={"Animals cannot be added while viewing hidden."}
                    >
                      <FontAwesomeIcon icon={faPlusSquare} className="fas" inverse />
                    </LoadingLink>
                    <LoadingLink
                      onClick={() => setShowTransfer(true)}
                      isLoading={isLoading} className="d-block" label="Transfer Animals Between Owners">
                      <FontAwesomeIcon icon={faRightLeft} className="fas" style={{cursor:'pointer'}} inverse />
                    </LoadingLink>
                    {showHidden ?
                    <LoadingLink
                      onClick={() => setShowHideModal(true)}
                      className="d-block"
                      isLoading={false}
                      label="Set Animals to Discoverable"
                      disabled={data.pre_reg_animals.filter(animal => animal.hidden === true).length === 0}
                      disabled_text={"Owner has no animals to make discoverable."}
                      >
                      <FontAwesomeIcon icon={faEye} className="fas" inverse />
                    </LoadingLink>
                    :
                    <LoadingLink
                      onClick={() => setShowHideModal(true)}
                      className="d-block"
                      isLoading={false}
                      label="Set Animals to Hidden"
                      disabled={data.pre_reg_animals.filter(animal => animal.hidden === false).length === 0}
                      disabled_text={"Owner has no animals to make hidden."}
                      >
                      <FontAwesomeIcon icon={faEyeSlash} className="fas" inverse />
                    </LoadingLink>
                    }
                  </ActionsDropdown>
                </Col>
              </Row>
            </div>
            <p className="phr"/>
            <AnimalCards animals={data.pre_reg_animals.filter(animal => animal.hidden === showHidden)} show_owner={false} show_status={true} organization={organization} incident={"/" + 'replace'} />
            {data.pre_reg_animals.filter(animal => animal.hidden === showHidden).length < 1 ? <p>This owner has no{showHidden ? " hidden" : ""} animals.</p> : ""}
          </Card.Body>
        </Card>
      </div>
    </div>
    <Modal show={showHideModal} onHide={handleShowHideClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm {showHidden ? "Discoverable" : "Hidden"} Animals</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {showHidden ? "Discoverable animals will" : "Hidden animals will no longer"} show up in incidents as PREREGISTERED for this owner. Please choose which animals you would like to {showHidden ? "make discoverable" : "hide"}:
        </p>
        {data.pre_reg_animals.filter(animal => animal.hidden === showHidden).map(animal => (
          <div key={animal.id} className="mt-1 mb-1" style={{height:"50px"}}>
            <div className="card-header rounded" style={{paddingLeft:"12px", height:"50px"}}>
              <MaterialCheckbox
                className={classes.root}
                disableRipple
                color="default"
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                slotProps={{ input: { 'aria-label': 'decorative radio' } }}
                checked={selectedAnimals.includes(animal.id) || false}
                onChange={() => {
                  if (selectedAnimals.includes(animal.id)) {
                    let newItems = [...selectedAnimals];
                    newItems = newItems.filter(id => id !== animal.id);
                    setSelectedAnimals(newItems);
                  }
                  else {
                    let newItems = [...selectedAnimals];
                    newItems.push(animal.id);
                    setSelectedAnimals(newItems);
                  }
                }}
                style={{
                  transform: "scale(1.5)",
                  marginTop: "-4px",
                  marginLeft:"-12px"
                }}
              />
              <label>
                A#{animal.id} - {animal.animal_count > 1 ? <span>{animal.animal_count} {capitalize(animal.species_string)}&nbsp;</span> : <span>{animal.name||"Unknown"}&nbsp;-&nbsp;{capitalize(animal.species_string)}&nbsp;</span>}
              </label>
            </div>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {handleShowHideSubmit()}} disabled={isLoading}>{isLoading ? "Sending..." : "Submit"}</Button>
        <Button variant="secondary" onClick={handleShowHideClose}>Close</Button>
      </Modal.Footer>
    </Modal>
    <Formik
      initialValues={{animal_ids:[], new_owner:null, previous_owner:data.id}}
      enableReinitialize={true}
      validationSchema={Yup.object({
      })}
      onSubmit={(values, { setSubmitting }) => {
        axios.patch('/people/api/pre-reg-person/transfer_animals/', values)
        .then(response => {
          setData(prevState => ({ ...prevState, pre_reg_animals:prevState.pre_reg_animals.filter(animal => !values.animal_ids.includes(animal.id))}));
          setSelectedAnimals([]);
          setShowTransfer(false);
        })
        .catch(error => {
          setShowSystemError(true);
        });
      }}
    >
      {formikProps => (
      <Modal show={showTransfer} onHide={handleCloseTransfer}>
        <Modal.Header closeButton>
          <Modal.Title>Transfer Animal Between Owners</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-2">
            Please select which animal(s) to transfer and who will be their new owner. Transferring animals to a new owner in this way will remove all previous owners.
          </p>
          <Row className="">
            <Col xs="12">
              {data.pre_reg_animals.map((animal, index) => (
                <div key={animal.id}>
                  <Checkbox
                    name={`animal_ids`}
                    checked={formikProps.values.animal_ids.includes(animal.id) || false}
                    onChange={() => {
                      if (formikProps.values.animal_ids.includes(animal.id)) {
                        let newItems = [...transferData.animal_ids];
                        newItems = newItems.filter(id => id !== animal.id);
                        setTransferData(prevState => ({...prevState, animal_ids: newItems}))
                        formikProps.setFieldValue(`animal_ids`, newItems);
                      }
                      else {
                        let newItems = [...transferData.animal_ids];
                        newItems.push(animal.id);
                        setTransferData(prevState => ({...prevState, animal_ids: newItems}));
                        formikProps.setFieldValue(`animal_ids`, newItems);
                      }
                    }}
                    style={{
                      transform: "scale(1.5)",
                      marginTop: "-4px"
                    }}
                  />
                  A#{animal.id} - {animal.animal_count > 1 ? <span>{animal.animal_count} {capitalize(animal.species_string)}</span> : <span>{animal.name||"Unknown Name"}&nbsp;-&nbsp;{capitalize(animal.species_string)}</span>}</div>
              ))}
              <label className="mt-2">New Owner:</label>
              <ExistingPersonSearch
                id="existing_owner"
                className="mt-2"
                ref={existingOwnerRef}
                params={{
                  organization: organization,
                }}
                emptyLabel="No matches found."
                onError={() => setShowSystemError(true)}
                onSelect={(existing_owner) => {
                  if (existing_owner) {
                    formikProps.setFieldValue("new_owner", existing_owner.id);
                  }
                  else {
                    formikProps.setFieldValue("new_owner", null);
                  }
                }}
                placeholder="Search by last name or phone number..."
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" disabled={!formikProps.values.new_owner || formikProps.values.animal_ids === 0} onClick={() => {formikProps.submitForm();}}>Save</Button>
          <Button variant="secondary" onClick={handleCloseTransfer}>Close</Button>
        </Modal.Footer>
      </Modal>
      )}
    </Formik>
    </>
  );
};

export default PreRegOwnerDetails;
